import { ElementType } from '@fiverr-private/bianka_js';
import { BiEventData, EventType, ReportBiEventParams, reportBiEvent } from '@fiverr-private/store_builder_bi_events';

export interface ClickEventData {
    biEventData: BiEventData;
    eventType: EventType;
    elementType: ElementType;
    pageName: string;
    elementName: string;
    storeBuilderToggleChoice?: 'shopify_services' | 'freelancer_store_builder';
}

export const reportClickEvent = ({
    biEventData,
    eventType,
    elementType,
    pageName,
    elementName,
    storeBuilderToggleChoice,
}: ClickEventData) => {
    const reportParams: ReportBiEventParams = {
        biEventData,
        activityType: 'click',
        eventType,
        elementName,
        elementType,
        pageName,
        storeBuilderToggleChoice,
    };

    reportBiEvent(reportParams);
};
